import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../styles/colorVariables';
import { Sizes } from '../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    logo: {
      width: 178,
      height: 34,
      marginBottom: 40,
      [theme.breakpoints.down(Sizes.tablet)]: {
        marginBottom: 50,
      },
    },
    orText: {
      textTransform: 'uppercase',
      fontSize: 14,
      marginBottom: 20,
    },
    loginFormBox: {
      position: 'relative',
      backgroundColor: colorVariables.white,
      boxShadow: '1px 2px 15px rgba(12, 82, 112, 0.15)',
      borderRadius: 10,
      width: 400,
      padding: '30px 35px',
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: 330,
        padding: '25px 15px',
      },
    },
    btnBox: {
      textAlign: 'center',
      paddingTop: 25,
    },
    fieldBox: {
      marginBottom: 15,
    },
    errorText: {
      fontSize: 12,
      lineHeight: '20px',
      color: colorVariables.red,
      fontStyle: 'italic',
      textAlign: 'center',
    },
    greenText: {
      color: colorVariables.green,
    },
    bottomBox: {
      marginTop: 30,
      opacity: 0.7,
      textAlign: 'center',
      lineHeight: '30px',
      paddingBottom: 30,
    },
    link: {
      fontWeight: 700,
      color: 'inherit',
      '&:hover': {
        color: colorVariables.blue,
      },
    },
    errorBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 10,
    },
    closeErrorBtn: {
      marginRight: 8,
      width: 20,
      height: 20,
      borderRadius: '50%',
      backgroundColor: '#FD0C0C',
      padding: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        backgroundColor: '#FD0C0C',
        opacity: 0.8,
      },
    },
    closeError: {
      fontSize: 16,
      color: colorVariables.white,
    },
    gBtnBox: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 20,
      marginTop: 20,
      '& iframe': {
        scale: 1.25,
        [theme.breakpoints.down(Sizes.mobile)]: {
          scale: 1.16,
        },
      },
    },
    recaptchaBox: {
      width: '100%',
      marginTop: 25,
      display: 'flex',
      justifyContent: 'center',
    },
  }),
);
